import { useQuery } from "@tanstack/react-query";
import { useIntl } from "react-intl";

import { type PickZone } from "@/schemas";
import { getPickZones } from "@/api/pick-zones-api";

export const PICK_ZONES_QUERY_KEY = "pick-zones";

export const usePickZones = () => {
	const intl = useIntl();

	return useQuery<PickZone[]>({
		queryKey: [PICK_ZONES_QUERY_KEY, intl],
		queryFn: () => getPickZones(intl),
		initialData: [],
		retry: false,
	});
};
